import { useCallback } from "react";
import { useCustomFetch } from "../custom-fetch";
import IUser from "../shared/IUser";

export interface IAuth {
  username: string;
  password: string;
}

export const useAuthService = () => {
  const customFetch = useCustomFetch();

  const authenticate = useCallback(async (auth: IAuth) => {
    const [data, resp] = await customFetch<any>('/json/auth', {
      method: "POST",
      body: JSON.stringify(auth),
    });
    if (!resp.ok) {
      throw new Error(data.status);
    }
    return data;
  }, [customFetch]);
  
  const authenticateFirebase = useCallback(async (idToken: string) => {
    const [data, resp] = await customFetch<any>('/json/auth/firebase', {
      method: "POST",
      body: JSON.stringify({ idToken }),
    });
    if (!resp.ok) {
      throw new Error(data.status || 'Firebase authentication failed');
    }
    return data;
  }, [customFetch]);
  
  const getAuthUser = useCallback(async (): Promise<IUser> => {
    const [data, resp] = await customFetch<any>('/json/users/currentuser', {});
    if (!resp.ok) {
      throw new Error(data.status);
    }
    return data.user;
  }, [customFetch]);

  const logoutUser = useCallback(async () => {
    const [data, resp] = await customFetch<any>('/json/users/logout', { method: 'GET' });
    if (!resp.ok) {
      throw new Error(data.status);
    }
    return data;
  }, [customFetch]);

  return { authenticate, authenticateFirebase, getAuthUser, logoutUser };
}




